// removed by extract-text-webpack-plugin
module.exports = {"action-result-wrapper":"action-result-wrapper","actionResultWrapper":"action-result-wrapper","action-text":"action-text","actionText":"action-text","action-failed-text":"action-failed-text","actionFailedText":"action-failed-text"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ldap/ldapTestConnectionButtonContainer/actionResult/style.scss
// module id = 1433
// module chunks = 0